import { SearchableItem, SearchableSelectionType } from "../interface";
import { CustomPageType } from "./enums";

export class CustomQuestion implements SearchableItem {
  FIELD_ID: number;
  schema: any;
  name: string;
  desc: string;
  type: string;
  page: CustomPageType;

  initial: boolean;
  selected = true;

  // Helpers
  active = false;
  allowed = false;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): CustomQuestion[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new CustomQuestion(j));
        }
      }
    }

    return arr;
  }

  static createQuestion(type: string, name: string, desc?: string, page?: CustomPageType): CustomQuestion {
    const cs = new CustomQuestion();
    cs.type = type;
    cs.name = name;
    cs.desc = desc;
    cs.initial = true;
    cs.schema = {};
    cs.page = page;
    return cs;
  }

  static cloneQuestion(q: CustomQuestion): CustomQuestion {
    const newQuestion: CustomQuestion = new CustomQuestion();
    newQuestion.schema = q.schema;
    newQuestion.name = q.name;
    newQuestion.type = q.type;
    newQuestion.initial = false;
    newQuestion.selected = false;
    newQuestion.page = q.page;

    return newQuestion;
  }

  getName(): string {
    return this.name;
  }

  getFullDetails(): string {
    return this.name;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}

export class CustomQuestionBank implements SearchableItem {
  ID: string;
  NAME: string;
  QUESTIONS: Array<CustomQuestionBankQuestion>;

  // Helpers
  active = false;
  allowed = false;

  constructor(value: any = {}) {
    Object.assign(this, value);

    this.QUESTIONS = CustomQuestionBankQuestion.parseArray(value.QUESTIONS)
  }

  static parseArray(json: any[]): CustomQuestionBank[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new CustomQuestionBank(j));
        }
      }
    }

    return arr;
  }

  static createBank(name: string): CustomQuestionBank {
    const bank = new CustomQuestionBank();
    bank.NAME = name;
    bank.QUESTIONS = [];
    return bank;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}

export class CustomQuestionBankQuestion implements SearchableItem {
  ID: string;
  NAME: string;
  QUESTIONS: Array<CustomQuestion>;

  // Helpers
  active = false;
  allowed = false;

  constructor(value: any = {}) {
    Object.assign(this, value);

    this.QUESTIONS = CustomQuestion.parseArray(value.QUESTIONS);
  }

  static parseArray(json: any[]): CustomQuestionBankQuestion[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new CustomQuestionBankQuestion(j));
        }
      }
    }

    return arr;
  }

  static createBankQuestion(name: string): CustomQuestionBankQuestion {
    const bank = new CustomQuestionBankQuestion();
    bank.NAME = name;
    bank.QUESTIONS = [];
    return bank;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
